import { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getProduct } from "@/lib/bokun.functions";
import { cancellationLabel, type CardFacts } from "@/lib/catalog-presentation";

/** Fetch policy only as a card enters view; reuse the existing product cache. */
export function TourCancellation({ tour }: { tour: CardFacts & { source?: string } }) {
  const { i18n } = useTranslation();
  const ref = useRef<HTMLSpanElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) { setVisible(true); observer.disconnect(); }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  const { data } = useQuery({
    queryKey: ["bokun", "card-policy", tour.id, i18n.language],
    queryFn: () => getProduct({ data: { id: tour.id, lang: i18n.language.slice(0, 2) } }),
    enabled: visible && tour.source !== "custom" && /^\d+$/.test(tour.id),
    staleTime: 5 * 60_000,
    retry: false,
  });
  const policy = data?.product.cardCancellationPolicy ?? tour.cardCancellationPolicy;
  return <span ref={ref}>{cancellationLabel({ ...tour, cardCancellationPolicy: policy }, i18n.language)}</span>;
}